<template>
    <v-container class="habits-table text-primary px-0">
        <div class="text-h4 text-primary mb-6">Привычки</div>

        <v-row v-if="habitsCount < habitsMaxCount">
            <v-col cols="12" sm="4" md="3" xl="2">
                <v-btn @click="createHabit = true"
                       class="w-100"
                       color="lonely"
                       variant="flat">Добавить привычку</v-btn>
            </v-col>
        </v-row>
        <v-row v-for="habit in habits" :key="habit.name">
            <v-col class="pt-0">
                <HabitCard :habit="habit" />               
            </v-col>
        </v-row>
    </v-container>

    <HabitCreationDialog v-if="createHabit"
                         @hide="createHabit = false"
                         @create:habit="createServerHabit($event)" />
</template>

<script>
    import HabitCard from "@/components/client/habits/HabitCard.vue";
    import HabitCreationDialog from "@/components/client/habits/HabitCreationDialog.vue";

    import { DateTime } from "luxon";

    export default {
        components: {
            HabitCard,
            HabitCreationDialog
        },

        data() {
            return {
                createHabit: false,
                habits: []
            };
        },

        computed: {
            currentDateTime() {
                return this.$store.state.currentDateTime;
            },
            startDateTime() {
                return this.$store.state.startDateTime;
            },
            endDateTime() {
                return this.$store.state.endDateTime;
            },
            selectedDateTime() {
                return this.$store.state.selectedDateTime;
            },
            isDateRange() {
                return this.startDateTime && this.endDateTime;
            },

            habitsMaxCount() {
                return this.$store.state.clientSettings?.habitsCount ?? 0;
            },
            habitsCount() {
                return this.habits?.length ?? 0;
            },

            serverHabits() {
                return this.$store.state.habits;
            }
        },

        watch: {
            selectedDateTime() {
                this.loadServerHabits();
            },

            selectedDateTimeRange() {
                this.loadServerHabits();
            },

            serverHabits(newValue) {
                this.updateLocalHabits(newValue);
            }
        },

        methods: {
            loadServerHabits() {
                this.$store.dispatch("loadHabits");
            },

            updateLocalHabits(serverHabits) {
                const localHabits = [];

                serverHabits.forEach(h => {
                    const habit = {
                        id: h.id,
                        name: h.name,
                        startDate: DateTime.fromISO(h.startDate),
                        endDate: DateTime.fromISO(h.endDate),
                        startDayIndex: h.startDayIndex,
                        isCompleted: h.isCompleted,
                        days: []
                    };

                    if (habit.startDayIndex > 0) {
                        const firstDate = habit.startDate.minus({ days: habit.startDayIndex });

                        for (let i = 0; i < habit.startDayIndex; i++) {
                            habit.days.push({
                                id: 0,
                                index: i,
                                number: 0,
                                date: firstDate.plus({ days: i }),
                                isDone: null
                            });
                        }
                    }

                    let number = 0;

                    h.days.forEach(d => {
                        if (d.isDone) {
                            number++;
                        }

                        habit.days.push({
                            id: d.id,
                            index: d.index,
                            number: d.isDone ? number : 0,
                            date: DateTime.fromISO(d.date),
                            isDone: d.isDone
                        });
                    });

                    localHabits.push(habit);
                });

                this.habits = localHabits;
            },

            createServerHabit(habit) {
                const request = {
                    id: habit.id,
                    name: habit.name,
                    startDate: habit.startDate.toFormat("yyyy-MM-dd"),
                    endDate: habit.endDate.toFormat("yyyy-MM-dd"),
                    startDayIndex: habit.startDayIndex,
                    isCompleted: habit.isCompleted,
                    days: habit.days
                        .filter(d => d.index >= habit.startDayIndex)
                        .map(d => ({
                            id: d.id,
                            index: d.index,
                            date: d.date.toFormat("yyyy-MM-dd"),
                            isDone: d.isDone
                        }))
                };

                this.$store.dispatch("createHabit", request)
                    .then(() => this.loadServerHabits());
            }
        }
    };
</script>

<style lang="scss">
    .habits-table {
    }
</style>